// https://developers.klaviyo.com/en/docs/track_klaviyo_form_activity_using_javascript#google-analytics-tracking-on-submit
window.addEventListener("klaviyoForms", function(e) { 
  if (e.detail.type == 'submit') {
    Shopify.analytics.publish("dex:lead", {
      email: e.detail.metaData.$email
    });
  };
});
